import { Storage } from "@faire/web/common/Storage";
import { AnnualSalesRangeOption } from "@faire/web-api--source/indigofair/data/AnnualSalesRangeOption";
import { IRetailerLaunchWithFaireApplication } from "@faire/web-api--source/indigofair/data/IRetailerLaunchWithFaireApplication";
import { ISignUpRequest } from "@faire/web-api--source/indigofair/data/ISignUpRequest";
import { IUser } from "@faire/web-api--source/indigofair/data/IUser";

export type PersonalInfoData = Pick<
  IUser,
  | "first_name"
  | "last_name"
  | "email_address"
  | "password"
  | "phone_number"
  | "locale_key"
> &
  Pick<ISignUpRequest, "country"> & {
    optedInToMarketingEmails?: boolean;
    receiveMarketingSMSs?: boolean;
  };

export type SignUpRequestExpanded = ISignUpRequest & {
  leaseSigned?: keyof typeof IRetailerLaunchWithFaireApplication.LeaseSigned;
  otherAnnualSalesSelected?: boolean;
  optedInToMarketingEmails?: boolean;
  other_business_platform_description?: string;
  isFD?: boolean;
  social_media?: string;
  isOwFGrantFlow?: boolean;
  isUpmarketEligible?: boolean;
  isVerticalizedSignUp?: boolean;
  annualSalesRangeOption?: keyof typeof AnnualSalesRangeOption;
};

export const signUpCache = {
  save: saveSignUpRequest,
  clear: clearSignUpRequest,
  get: getSignUpRequest,
};

function saveSignUpRequest(data: SignUpRequestExpanded) {
  Storage.session.setItem(SIGNUP_REQUEST_DATA_KEY, JSON.stringify(data));
}

function clearSignUpRequest() {
  Storage.session.removeItem(SIGNUP_REQUEST_DATA_KEY);
}

function getSignUpRequest(): SignUpRequestExpanded {
  const data = Storage.session.getItem(SIGNUP_REQUEST_DATA_KEY);
  if (data) {
    try {
      return JSON.parse(data);
    } catch {
      return ISignUpRequest.build();
    }
  }
  return ISignUpRequest.build();
}

const SIGNUP_REQUEST_DATA_KEY = "SIGNUP_REQUEST_DATA_KEY";
